import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ApplicationState from "@SupplyLand/Store/ApplicationState";
import React, { useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    isModalOpen: boolean;
    onStaySignedInHandler: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    extendedStyles?: SupplyLandInactivityModalStyles;
}

const mapStateToProps = (state: ApplicationState) => ({
    isGuest: state.context.session.isGuest,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface SupplyLandInactivityModalStyles {
    modal?: ModalPresentationProps;
    container?: GridContainerProps;
    messageGridItem?: GridItemProps;
    message?: InjectableCss;
    staySignedInGridItem?: GridItemProps;
    staySignedInButton?: ButtonPresentationProps;
}

export const supplyLandInactivityModalStyles: SupplyLandInactivityModalStyles = {
    modal: {
        cssOverrides: {
            modalContainer: css`
                min-width: 450px;
            `,
            modalBody: css`
                width: auto;
                max-width: initial;
                max-height: initial !important;
            `,
            modalTitle: css`
                border-bottom: none;
                padding: 10px 10px 0;
            `,
            modalContent: css`
                text-align: center;
            `,
        },
    },
    container: {
        gap: 20,
        offsetCss: css`
            justify-content: center;
        `,
    },
    messageGridItem: {
        width: 12,
        css: css`
            justify-content: center;
        `,
    },
    message: {
        css: css`
            margin-bottom: 20px;
        `,
    },
    staySignedInGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    staySignedInButton: {
        css: css`
            color: black;
            width: 100%;
        `,
    },
};

const SupplyLandInactivityModal: React.FC<Props> = ({
    isModalOpen,
    onStaySignedInHandler,
    extendedStyles,
    isGuest,
}: Props) => {
    const [styles] = useState(() => mergeToNew(supplyLandInactivityModalStyles, extendedStyles));

    return (
        <Modal isOpen={isModalOpen} headline="Uh-oh!" isCloseable handleClose={onStaySignedInHandler} closeOnEsc>
            <GridContainer {...styles.container}>
                <GridItem {...styles.messageGridItem}>
                    {isGuest ? (
                        <Typography {...styles.message}>Your session will expire in 3 minutes.</Typography>
                    ) : (
                        <Typography {...styles.message}>Your account will log out in 3 minutes.</Typography>
                    )}
                </GridItem>
                <GridItem {...styles.staySignedInGridItem}>
                    {isGuest ? (
                        <Button {...styles.staySignedInButton} variant="primary" onClick={onStaySignedInHandler}>
                            Continue Session
                        </Button>
                    ) : (
                        <Button {...styles.staySignedInButton} variant="primary" onClick={onStaySignedInHandler}>
                            Keep me logged in
                        </Button>
                    )}
                </GridItem>
            </GridContainer>
        </Modal>
    );
};

export default connect(mapStateToProps)(SupplyLandInactivityModal);
